module.exports = ".header::first-letter, .dialog-message::first-letter {\r\n  text-transform: uppercase;\r\n}\r\n.btn-cancel {\r\n  background-color: red;\r\n  color: #fff;\r\n}\r\n.center {\r\n  display: block;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  width: 90px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/common-dialog-notification/common-dialog-notification.component.css
// module id = ./src/app/shared/common-dialog-notification/common-dialog-notification.component.css
// module chunks = main